import { StepsGG } from '../../../components/navigation-component/navigation-settings.service';
import { ApplicationStepperLabels } from './application-page.settings';

const NavigationStepperMapper = {
  [ApplicationStepperLabels.PRODUCT_INFO]: StepsGG.PRODUCT_INFO,
  [ApplicationStepperLabels.KNOWLEDGE_TEST_1]: StepsGG.KNOWLEDGE_TEST,
  [ApplicationStepperLabels.KNOWLEDGE_TEST_2]: StepsGG.KNOWLEDGE_TEST,
  [ApplicationStepperLabels.KNOWLEDGE_TEST_3]: StepsGG.KNOWLEDGE_TEST,
  [ApplicationStepperLabels.PERSONAL_DATA]: StepsGG.PERSONAL_DATA,
  [ApplicationStepperLabels.SUMMARY]: StepsGG.COMPLETE,
  [ApplicationStepperLabels.IDENTITY_VERIFICATION]: StepsGG.COMPLETE,
  [ApplicationStepperLabels.THANK_YOU_PAGE]: StepsGG.COMPLETE,
};

export default NavigationStepperMapper;
